import React from "react";
import classes from "./Create.module.css";

const Create = () => {
  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <h1>
          <span>WE ARE CREATING THE FUTURE</span> through an intense synergy of
          activities in the technological and innovation ecosystem.
        </h1>
        <p>
          Elrae is a technologically driven and an idea creating firm. We
          leverage technology to bring ideas into reality by creating impactful
          and scalable solutions that will positively affect our world.
        </p>
        <p>
          For us at Elrae, we are young and extremely dynamic; shifting and
          adapting, managing scenarios and their consequences by rising above
          all challenges to create a product for the world irrespective of the
          presence of absence of mental boxes and limitations. It's this one
          thing that separates us from the rest.{" "}
        </p>
        <p>
          We focus on Information Technology Solutions, software development and
          enterprise solutions. We are bent on creating a Future that unites
          People, Business and Technology.
        </p>
      </div>
    </div>
  );
};

export default Create;
